module.exports = __webpack_public_path__ + "assets/img/teacher (48).210f4ecd.png";